import liff from "./liff";

export default axiosInstance => {
  return {
    liff: liff(axiosInstance)
  };
};
